export default {"src":"/_next/static/media/power.757ec369.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};